<template>
    <div class="row">
        <div class="col-lg-4 input-group pb-2 mb-4 label">
            <div class="col-lg-12 px-0">
                <div class="row">
                    <div class="col-lg-6">
                        <span>Continent</span>
                    </div>
                    <div class="col-lg-6">
                        <core-drop-down
                            v-model="selected"
                            wrapperClass="row"
                            :items="continents"
                            :selectedValue="selectedValue"
                            v-if="continents.length"
                            noWrapper
                        ></core-drop-down>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Geo from '@/services/hatsApi/Geo'

export default {
  data () {
    return {
      selected: null,
      continents: []
    }
  },
  watch: {
    // whenever selected changes, this function will run
    selected () {
      this.$emit('input', this.selected)
    }
  },
  created () {
    if (this.selectedValue) {
      this.selected = this.selectedValue
      this.$emit('input', this.selected)
    }

    Geo.getContinents().then((response) => {
      this.continents = response.data.data

      if (this.continents.length && !this.selectedValue) {
        this.selected = this.continents[0].id
        this.$emit('input', this.selected)
      }
    })
  },
  props: {
    selectedValue: {
      default: null,
      type: String | Number,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ContinentsDropDown.vue